module.exports = __webpack_public_path__ + "img/breezeInMarch.e5e9727a.png";